export const facebook = 'https://www.facebook.com'
export const twitter = 'https://www.twitter.com'
export const instagram = 'https://www.instagram.com'